import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { CatalogPage } from "./pages/CatalogPage";
import { Toaster } from "./components/ui/sonner";
import { InstallPWABanner } from "./components/InstallPWABanner";
// import { NotificationPrompt } from "./components/NotificationPrompt";

function App() {
    return (
        <CartProvider>
            <div className="App">
                <InstallPWABanner />
                {/* <NotificationPrompt /> */}
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<CatalogPage />} />
                        <Route path="*" element={<CatalogPage />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-center" />
            </div>
        </CartProvider>
    );
}

export default App;
